import { render } from "./QuizFinalDayFallingEffect.vue?vue&type=template&id=783af0ea&scoped=true"
import script from "./QuizFinalDayFallingEffect.vue?vue&type=script&lang=js"
export * from "./QuizFinalDayFallingEffect.vue?vue&type=script&lang=js"

import "./QuizFinalDayFallingEffect.vue?vue&type=style&index=0&id=783af0ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783af0ea"]])

export default __exports__